import React, { useEffect, useState } from 'react';
import api from '../../../../services/api';
import { LineData } from '../LineData/LineData';

export const Borda = ({ data }) => {
  const [border, setBorder] = useState({});

  const getBorderPrice = () => {
    if (Number(border?.PrecoDesconto) > 0) {
      return Number(border?.PrecoDesconto);
    }
  
    return (Number(border?.Preco) || 0);
  }

  useEffect(() => {
    if (data?.IdBorda) {
      api
        .get(`/pedido-borda/encontrar/${data.IdBorda}`)
        .then((res) => {
          if (!res.data?.Id) {
            throw new Error('Borda não encontrada');
          }
          setBorder(res.data);
        })
        .catch((error) => console.log(error));
    }
  }, [data?.IdBorda]);

  return (
    <LineData
      label="Borda:"
      description={border.Descricao}
      price={getBorderPrice()}
    />
  );
};
